export default __webpack_public_path__ + "static/media/logo.fd8ce6c7.svg";